import Loader from "react-js-loader";

declare module 'react-js-loader';

export default Loader